<div
  *ngIf="!loading"
  class="p-fluid">
  <p-messages
    *ngIf="externalUser"
    severity="info">
    <ng-template pTemplate="">
      <div class="flex gap-2 align-items-center">
        <i
          class="pi pi-exclamation-circle"
          style="font-size: 1.3rem"></i>
        <p>Внешний пользователь из этой заявки перенесется на нового клиента.</p>
      </div>
    </ng-template>
  </p-messages>

  <div class="field">
    <label class="font-medium">Клиент</label>
    <crm-client-auto-complete
      [(selectedClient)]="client"
      [customSearch]="false"
      appendTo="body"></crm-client-auto-complete>
  </div>
</div>
<div
  *ngIf="!loading"
  class="flex gap-3 justify-content-end">
  <div>
    <button
      pButton
      label="Сохранить"
      icon="pi pi-check"
      class="p-button-success"
      [disabled]="!client?.id"
      (click)="save()"></button>
  </div>
  <div>
    <button
      pButton
      label="Отмена"
      class="p-button-text"
      (click)="ref?.close({ client: null, isShowClientModal: true })"></button>
  </div>
</div>

<crm-spinner *ngIf="loading"></crm-spinner>
